import React, { useState, useContext } from "react";
import {
  Table,
  Card,
  Button,
  Space,
  Tag,
  Input,
  Modal,
  Typography,
  Divider,
  Dropdown,
  Menu,
} from "antd";
import {
  DownloadOutlined,
  EyeOutlined,
  SearchOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
//import { Document, Page } from "react-pdf";
import { AppContext } from "../context/AppContext";
import PdfViewer from "./PdfViewer";

const { Title, Text } = Typography;

const DocumentsPage = () => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [searchText, setSearchText] = useState("");
  const { role } = useContext(AppContext); // Assuming you have context for user roles

  // Update the PDF preview modal to handle loading and errors
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Sample documents data - replace with API data
  const [documents] = useState([
    {
      id: 1,
      name: "Business Process Diagram",
      category: "Business",
      date: "2024-02-15",
      version: "2.1",
      size: "2.5 MB",
      url: "/docs/business_process.pdf",
      access: ["admin", "underwriter"],
    },
    {
      id: 2,
      name: "Collateral Inspection Document",
      category: "Business",
      date: "2024-02-25",
      version: "2.1",
      size: "2.5 MB",
      url: "/docs/inspection.pdf",
      access: ["admin", "underwriter"],
    },
  ]);

  const categories = [
    { text: "Legal", value: "Legal" },
    { text: "Compliance", value: "Compliance" },
    { text: "Templates", value: "Templates" },
    { text: "Reports", value: "Reports" },
  ];

  const columns = [
    {
      title: "Document Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => (
        <Space>
          <FilePdfOutlined style={{ color: "#e74c3c" }} />
          <Text strong>{text}</Text>
        </Space>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      filters: categories,
      onFilter: (value, record) => record.category === value,
      render: (category) => <Tag color="#2ecc71">{category}</Tag>,
    },
    {
      title: "Last Updated",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            onClick={() => {
              setSelectedDoc(record);
              setPreviewVisible(true);
            }}
          >
            Preview
          </Button>
          <Button
            icon={<DownloadOutlined />}
            type="primary"
            href={record.url}
            download
          >
            Download
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="page-container">
      <Card
        title={
          <Space>
            <FilePdfOutlined />
            <Title level={4} style={{ margin: 0 }}>
              Document Repository
            </Title>
          </Space>
        }
        extra={
          <Space>
            <Input
              placeholder="Search documents..."
              prefix={<SearchOutlined />}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
            {role && (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="upload">
                      <Button type="link">Upload New Document</Button>
                    </Menu.Item>
                    <Menu.Item key="manage">
                      <Button type="link">Manage Categories</Button>
                    </Menu.Item>
                  </Menu>
                }
              >
                <Button type="primary">Manage Documents</Button>
              </Dropdown>
            )}
          </Space>
        }
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={documents.filter((doc) =>
            doc.name.toLowerCase().includes(searchText.toLowerCase())
          )}
          pagination={{ pageSize: 8 }}
          scroll={{ x: true }}
        />

        <Modal
          title={selectedDoc?.name}
          visible={previewVisible}
          width="80%"
          onCancel={() => setPreviewVisible(false)}
          footer={null}
          destroyOnClose
        >
          {selectedDoc && (
            <div style={{ height: "90vh", overflow: "auto" }}>
              <PdfViewer fileUrl={selectedDoc.url} />
            </div>
          )}
        </Modal>
      </Card>
    </div>
  );
};

export default DocumentsPage;
